import { render, staticRenderFns } from "./Garantia.vue?vue&type=template&id=a59697b2"
import script from "./Garantia.vue?vue&type=script&lang=js"
export * from "./Garantia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports